import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import { IToasterInput } from '../model/interfaces';


@Injectable()
export class InternalMsgService {

    private toggleSpinnerSource = new Subject<boolean>();
    toggleSpinnerSet$ = this.toggleSpinnerSource.asObservable();
    ontoggleSpinnerSet(toggle: boolean): void {
        this.toggleSpinnerSource.next(toggle);
    }

    private showToasterSource = new Subject<IToasterInput>();
    showToasterSet$ = this.showToasterSource.asObservable();
    onShowToasterSet(input: IToasterInput): void {
        this.showToasterSource.next(input);
    }
}
